import { Text } from '@chakra-ui/react';

import CrudGrid from '~/common/components/CrudGrid';
import type { GridDef } from '~/common/components/CrudGrid/GridDef';

import Loan1003FormSection from '../../common/components/Loan1003FormSection';
import { useGetAssetsSummaryInformationQuery } from '../hooks';
import { assetColumns } from './assetColumns';

const excludedAssetsGridDef: GridDef = {
  defaultSort: { field: 'balance', direction: 'desc' },
  uniqueIdAttributeFields: ['assetId'],
  allowFilters: false,
  gridLanguage: {
    singularItem: 'Asset',
    pluralItem: 'Assets',
  },
};

export function ExcludedAssetsTable() {
  const { data, isLoading } = useGetAssetsSummaryInformationQuery();

  if (!data.excludedAssets?.length) {
    return null;
  }

  return (
    <>
      <Loan1003FormSection title="Excluded Assets">
        <Text mb={'1.5rem'}>
          The following asset(s) were removed. Return to the Asset
          Reconciliation page in the BOLT tab to make updates.
        </Text>
      </Loan1003FormSection>
      <CrudGrid
        gridDef={excludedAssetsGridDef}
        columns={assetColumns}
        data={data.excludedAssets}
        isLoading={isLoading}
        readOnly={true}
        disableRowClick={true}
      />
    </>
  );
}
